"use client";

import { c as _c } from "react/compiler-runtime";
import React, { useState } from "react";
import { jobOpeningsData } from "@/data/JobOpeningsData";
import JobOpeningItem from "./JobOpeningItem";
import JobModal from "./JobModal";
import { JobOpeningProps } from "@/lib/types";
import { isDeadlinePassed } from "@/lib/utils/date";

// Open roles lead the list — a closed posting never sits above one someone can
// still apply to. Inside each group the newest posting comes first, so a fresh
// opening lands at the top of the page on the day it goes live.
const orderJobs = (jobs: JobOpeningProps[]) => [...jobs].sort((a, b) => {
  const byStatus = Number(isDeadlinePassed(a.deadline)) - Number(isDeadlinePassed(b.deadline));
  return byStatus !== 0 ? byStatus : b.postedAt.localeCompare(a.postedAt);
});
const JobOpeningsList = () => {
  const $ = _c(5);
  const [selectedJob, setSelectedJob] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const orderedJobs = orderJobs(jobOpeningsData);
    const handleOpenModal = job => {
      setSelectedJob(job);
      setIsModalOpen(true);
    };
    t0 = <div className="flex flex-col">{orderedJobs.map((job_0, idx) => <JobOpeningItem key={job_0.id} job={job_0} onClick={handleOpenModal} idx={idx} />)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsModalOpen(false);
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isModalOpen || $[3] !== selectedJob) {
    t2 = <div>{t0}<JobModal isOpen={isModalOpen} onClose={t1} job={selectedJob} /></div>;
    $[2] = isModalOpen;
    $[3] = selectedJob;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export default JobOpeningsList;